import { render, staticRenderFns } from "./CodeViewer.vue?vue&type=template&id=cbaa4568&scoped=true"
import script from "./CodeViewer.vue?vue&type=script&lang=js"
export * from "./CodeViewer.vue?vue&type=script&lang=js"
import style0 from "./CodeViewer.vue?vue&type=style&index=0&id=cbaa4568&prod&lang=scss&scoped=true"
import style1 from "./CodeViewer.vue?vue&type=style&index=1&id=cbaa4568&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbaa4568",
  null
  
)

export default component.exports